import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import BlockIcon from '@material-ui/icons/Block';

const DeactivateButton = memo(({ title, ...rest }) => {
  const { t } = useTranslation();
  return (
    <IconButton title={t(title)} {...rest}>
      <BlockIcon />
    </IconButton>
  );
});

DeactivateButton.propTypes = {
  ...IconButton.propTypes,
};

DeactivateButton.defaultProps = {
  ...IconButton.defaultProps,
  title: 'app:deactivate',
};

export default DeactivateButton;
